export default [

     {
          path: '/glossary-version',
          name: 'GlossaryVersion',
          component: () => import("@/views/Page/GlossaryVersion/GlossaryVersion.vue"),
           meta: {
               title: '#Default# | GlossaryVersion',
          },
     }
];